module.exports = __webpack_public_path__ + "img/pan_reports_icon.98528df3.svg";